import { render } from "./tvshowsPage.vue?vue&type=template&id=75e45edd&scoped=true"
import script from "./tvshowsPage.vue?vue&type=script&lang=js"
export * from "./tvshowsPage.vue?vue&type=script&lang=js"

import "./tvshowsPage.vue?vue&type=style&index=0&id=75e45edd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e45edd"]])

export default __exports__